import { INavigationMenu } from 'interfaces/navigationMenu.interface'

export type EpidemiologySlugs =
  | ''
  | 'overview'
  | 'variants'
  | 'latest-news'
  | 'impact'
  | 'reports'
  | 'variant-prevalence'
  | 'epidemiology-across-respiratory-diseases'
  | 'respiratory-disease-cases'
  | 'protection-vaccinations'
  | 'initial-and-boosters'
  | 'research-briefs'
  | 'wastewater'

const EpidemiologyMenu: Array<INavigationMenu<EpidemiologySlugs>[]> = [
  [
    {
      title: 'Epid Overview',
      slug: 'overview',
      defaultOpen: true,
      description: '',
      createdAt: new Date(2022, 0, 25),
      children: [
        {
          title: 'Epidemiology across Respiratory Diseases',
          slug: 'epidemiology-across-respiratory-diseases',
          createdAt: new Date(2025, 7, 26),
        },
        {
          title: 'Respiratory Disease Cases',
          slug: 'respiratory-disease-cases',
          createdAt: new Date(2024, 1, 28),
        },
        {
          title: 'Wastewater',
          slug: 'wastewater',
          createdAt: new Date(2024, 3, 11),
          updatedAt: new Date(2024, 5, 27),
        },
      ],
    },
    {
      title: 'Variants',
      description: '',
      slug: 'variants',
      createdAt: new Date(2022, 1, 7),
      children: [
        {
          title: 'Latest News',
          slug: 'latest-news',
          createdAt: new Date(2022, 1, 7),
        },
        {
          title: 'Variant Prevalence',
          slug: 'variant-prevalence',
          createdAt: new Date(2024, 3, 11),
        },
        {
          title: 'Impact of Variants',
          slug: 'impact',
          createdAt: new Date(2022, 1, 7),
        },
      ],
    },
    {
      title: 'Reports',
      slug: 'reports',
      createdAt: new Date(2022, 12, 6),
      children: [
        {
          title: 'Reports',
          slug: '',
          createdAt: new Date(2022, 3, 13),
        },
        {
          title: 'Research Briefs',
          slug: 'research-briefs',
          createdAt: new Date(2022, 7, 24),
        },
      ],
    },
  ],
]

export { EpidemiologyMenu }
